import React, { useMemo } from 'react';
import Modal, { ModalBody, ModalFooter } from "Components/Modal";
import { Button } from "Components";
import { Typography, Box, Chip } from "@mui/material";
import { useIntl } from "react-intl";
import { HasPermission } from '../../../../security';
import { useSelector } from 'react-redux';

const DataDetailsModal = ({ open, onClose, data, importType, messages }) => {
    // const { messages } = useIntl();
    const user = useSelector(state => state.securityRedux.user);
    const evirPermissions = HasPermission(user, 'evir');
    const zonarELDPermissions = HasPermission(user, 'zlogs');
    // Field configuration for different data types
    const fieldConfigs = useMemo(() => {
        const baseConfig = {
            tag: {
                id: { label: 'tag: Id', type: 'text' },
                label: { label: 'tag: Label', type: 'text' },
                color: { label: 'tag: color', type: 'color' },
                parentLabel: { label: 'tag: parentLabel', type: 'text' }
            },
            unit: {
                esn: { label: 'unit: ESN', type: 'text' },
                id: { label: 'unit: Id', type: 'text' },
                label: { label: 'unit: Label', type: 'text' },
                driver: { label: 'unit: Driver', type: 'text' },
                engineHours: { label: 'unit: Engine Hours', type: 'text' },
                defaultDriver: { label: 'unit: Default Driver', type: 'text' },
                odometer: { label: 'unit: Odometer', type: 'text' },
                'vehicleInformation.vin': { label: 'unit: VIN', type: 'text' },
                'vehicleInformation.make': { label: 'unit: Make', type: 'text' },
                'vehicleInformation.model': { label: 'unit: Model', type: 'text' },
                'vehicleInformation.year': { label: 'unit: Year', type: 'text' },
                'zonarAsset.registrationCountry': { label: 'unit: Registration Country', type: 'text' },
                'zonarAsset.registrationState': { label: 'unit: Registration State', type: 'text' },
                'zonarAsset.registrationExpirationDate': { label: 'unit: Registration Expiration', type: 'text' },
                'zonarAsset.engineSerialNumber': { label: 'unit: Engine Serial Number', type: 'text' },
                'zonarAsset.licensePlate': { label: 'unit: License Plate', type: 'text' },
                'zonarAsset.assetType': { label: 'unit: Asset Type', type: 'text' },
                'zonarAsset.assetSubtype': { label: 'unit: Asset Subtype', type: 'text' },
                'zonarAsset.maintenanceCompany': { label: 'unit: Maintenance Company', type: 'text' },
            },
            asset: {
                id: { label: 'asset: Id', type: 'text' },
                label: { label: 'asset: Label', type: 'text' },
                status: { label: 'asset: Status', type: 'text' },
                externalId: { label: 'asset: External ID', type: 'text' },
                assetTypeName: { label: 'asset: Asset Type', type: 'text' },
                assetSubtypeName: { label: 'asset: Asset Subtype', type: 'text' },
                vin: { label: 'asset: VIN', type: 'text' },
                make: { label: 'asset: Make', type: 'text' },
                model: { label: 'asset: Model', type: 'text' },
                year: { label: 'asset: Year', type: 'text' },
                inspectionDeviceType: { label: 'asset: Inspection Device Type', type: 'text' },
                inspectionTagId: { label: 'asset: Inspection Tag ID', type: 'text' },
                powerUnitNumber: { label: 'asset: Power Unit Number', type: 'text' },
                maintenanceCompany: { label: 'asset: Maintenance Company', type: 'text' },
                registrationCountry: { label: 'asset: Registration Country', type: 'text' },
                registrationState: { label: 'asset: Registration State', type: 'text' },
                registrationExpiration: { label: 'asset: Registration Expiration', type: 'text' },
                engineSerialNumber: { label: 'asset: Engine Serial Number', type: 'text' },
                chassisSerialNumber: { label: 'asset: Chassis Serial Number', type: 'text' },
                licensePlate: { label: 'asset: License Plate', type: 'text' },
            },
            user: {
                id: { label: 'user: Id', type: 'text' },
                firstName: { label: 'user: First Name', type: 'text' },
                lastName: { label: 'user: Last Name', type: 'text' },
                username: { label: 'user: Username', type: 'text' },
                email: { label: 'user: Email', type: 'text' },
                phone: { label: 'user: Cell', type: 'text' },
                role: { label: 'user: Role', type: 'text' },
                expiryDate: { label: 'user: Expiration Date', type: 'text' },
            },
                        driver: {
                                id: { label: 'driver: Id', type: 'text' },
                                code: { label: 'driver: Code', type: 'text' },
                                name: { label: 'driver: Name', type: 'text' },
                                employeeNumber: { label: 'driver: Employee Number', type: 'text' },
                                keyFob: { label: 'driver: KeyFob', type: 'text' },
                                supervisor: { label: 'driver: Supervisor', type: 'text' },
                                vehicle: { label: 'driver: Vehicle', type: 'text' },
                                status: { label: 'driver: Status', type: 'text' },
                                timezone: { label: 'driver: Timezone', type: 'text' },
                                tags: { label: 'driver: Tags', type: 'text' },
                                email: { label: 'driver: Email', type: 'text' },
                                phone: { label: 'driver: Phone', type: 'text' },
                                appUsername: { label: 'driver: Ignition Driver app', type: 'text' },
                                pinNumber: { label: 'driver: Pin Number', type: 'text' },
                                licenseNumber: { label: 'driver: License Number', type: 'text' },
                                licenseExpirationDate: { label: 'driver: License Expiration', type: 'text' },
                                registrationCountry: { label: 'driver: Registration Country', type: 'text' },
                                registrationState: { label: 'driver: Registration State', type: 'text' },
                                hosRuleset: { label: 'driver: Hours of Service Ruleset', type: 'text' },
                                ...(zonarELDPermissions ? {
                                    hosExempt: { label: 'driver: Hours of Service Exempt', type: 'text' },
                                    hosExemptComment: { label: 'driver: Exempt Comment', type: 'text' },
                                    personalConveyance: { label: 'driver: Personal Conveyance', type: 'text' },
                                    allowedPCDistance: { label: 'driver: Allowed PC Distance', type: 'text' },
                                    personalYardMoves: { label: 'driver: Yard Moves', type: 'text' },
                                } : {}),
                        }
        };

        // Conditionally add permission-based fields to unit
        if (evirPermissions) {
            baseConfig.unit['zonarAsset.inspectionDeviceType'] = { label: 'unit: Inspection Device Type', type: 'text' };
            baseConfig.unit['zonarAsset.inspectionTagId'] = { label: 'unit: Inspection Tag ID', type: 'text' };
        }

        if (zonarELDPermissions) {
            baseConfig.unit['zonarAsset.powerUnitNumber'] = { label: 'unit: Power Unit Number', type: 'text' };
        }

        return baseConfig;
    }, [evirPermissions, zonarELDPermissions]);

    const getNestedValue = (obj, path) => {
        return path.split('.').reduce((current, key) => current?.[key], obj);
    };

    const driverKeyAliases = {
        allowedPCDistance: ['allowedPcDistance', 'allowed_pc_distance', 'Allowed PC Distance', 'specialDutyStatuses.PCD']
    };

    const renderField = (key, value, fieldConfig) => {
        if (fieldConfig.type === 'color') {
            value = value.replace('#', ''); // Remove # if it exists
        }
        if (value === null || value === undefined || value === '') {
            return (
                <Typography 
                    variant="body2" 
                    sx={{ color: '#9e9e9e', fontStyle: 'italic' }}
                >
                    -
                </Typography>
            );
        }

        switch (fieldConfig.type) {
            case 'color':
                return (
                    <Box display="flex" alignItems="center" gap={1}>
                        <Box 
                            sx={{
                                width: 20,
                                height: 20,
                                backgroundColor: `#${value}`,
                                borderRadius: '4px',
                                border: '1px solid #ccc',
                                flexShrink: 0
                            }}
                        />
                        <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                            #{value}
                        </Typography>
                    </Box>
                );
            case 'array':
                return (
                    <Box display="flex" gap={1} flexWrap="wrap">
                        {value.map((item, index) => (
                            <Chip 
                                key={index}
                                label={item} 
                                size="small" 
                                variant="outlined"
                                sx={{
                                    fontSize: '0.75rem',
                                    height: '24px'
                                }}
                            />
                        ))}
                    </Box>
                );
            default:
                return (
                    <Typography 
                        variant="body2" 
                        sx={{ 
                            wordBreak: 'break-word',
                            fontWeight: 500,
                            color: '#2c2c2c'
                        }}
                    >
                        {String(value)}
                    </Typography>
                );
        }
    };

    const getMainDataObject = () => {
        if (!data) return { object: null, type: null };

        // Determine the main object type and data
        if (data.tag) return { object: data.tag, type: 'tag' };
        if (data.unit) return { object: data.unit, type: 'unit' };
        if (data.asset) return { object: data.asset, type: 'asset' };
        if (data.user) return { object: data.user, type: 'user' };
        if (data.driver) return { object: data.driver, type: 'driver' };
        
        return { object: null, type: null };
    };

    const renderSpecialFields = () => {
        const specialFields = [];

        // Add tags array for units
        if (data?.tags?.length > 0) {
            specialFields.push(
                <Box 
                    key="tags" 
                    sx={{ 
                        gridColumn: 'span 2',
                        padding: 2,
                        backgroundColor: '#f8f9fa',
                        borderRadius: 1,
                        border: '1px solid #e9ecef'
                    }}
                >
                    <Typography 
                        variant="caption" 
                        color="textSecondary" 
                        fontWeight={700}
                        sx={{ 
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            fontSize: '0.7rem'
                        }}
                    >
                        {messages['import_unit_tags'] || 'Tags'}
                    </Typography>
                    <Box 
                        display="flex" 
                        gap={1} 
                        flexWrap="wrap" 
                        sx={{ marginTop: 1 }}
                    >
                        {data.tags.map((tag, index) => (
                            <Chip 
                                key={index}
                                label={tag} 
                                size="small" 
                                variant="outlined"
                                sx={{
                                    fontSize: '0.75rem',
                                    height: '28px',
                                    backgroundColor: '#fff',
                                    borderColor: '#1976d2',
                                    color: '#1976d2',
                                    '&:hover': {
                                        backgroundColor: '#e3f2fd'
                                    }
                                }}
                            />
                        ))}
                    </Box>
                </Box>
            );
        }

        return specialFields;
    };

    if (!open || !data) {
        return null;
    }

    const { object: mainObject, type: objectType } = getMainDataObject();
    const specialFields = renderSpecialFields();

    return (
        <Modal
            open={open}
            title={messages['import_data_details'] || 'Data Details'}
            size="small"
            position="right"
            handleClose={onClose}
        >
            <ModalBody>
                <Box 
                    display="grid" 
                    gridTemplateColumns="1fr 1fr" 
                    gap={3}
                    sx={{ 
                        padding: 1,
                        maxHeight: 'calc(100vh - 200px)', // Limit the height
                        overflowY: 'auto', // Enable vertical scrolling
                        overflowX: 'hidden' // Prevent horizontal scrolling
                    }}
                >
                    {/* Special fields first (companyId, tags array) */}
                    {specialFields}
                    
                    {/* Main object fields */}
                    {mainObject && objectType && (
                        <>
                            {Object.entries(fieldConfigs[objectType] || {}).map(([fieldKey, fieldConfig]) => {
                                let actualValue = fieldKey.includes('.')
                                    ? getNestedValue(mainObject, fieldKey)
                                    : mainObject[fieldKey];

                                if (actualValue === undefined && objectType === 'driver' && driverKeyAliases[fieldKey]) {
                                    for (const altKey of driverKeyAliases[fieldKey]) {
                                        const altValue = altKey.includes('.')
                                            ? getNestedValue(mainObject, altKey)
                                            : mainObject[altKey];
                                        if (altValue !== undefined) {
                                            actualValue = altValue;
                                            break;
                                        }
                                    }
                                }

                                // Skip if no value exists
                                if (actualValue === undefined) return null;
                                
                                const isWideField = fieldConfig.type === 'color' || fieldConfig.type === 'array';
                                return (
                                    <Box 
                                        key={fieldKey} 
                                        sx={{ 
                                            gridColumn: isWideField ? 'span 2' : 'span 1',
                                            padding: 1.5,
                                            backgroundColor: '#ffffff',
                                            borderRadius: 1,
                                            border: '1px solid #e0e0e0',
                                            '&:hover': {
                                                backgroundColor: '#fafafa',
                                                borderColor: '#c0c0c0'
                                            },
                                            transition: 'all 0.2s ease'
                                        }}
                                    >
                                        <Typography 
                                            variant="caption" 
                                            color="textSecondary" 
                                            fontWeight={700}
                                            sx={{ 
                                                display: 'block',
                                                marginBottom: 1,
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                fontSize: '0.7rem'
                                            }}
                                        >
                                            {messages[`import_${fieldConfig.label.toLowerCase().replace(/[^a-z0-9]/g, '_')}`]}
                                        </Typography>
                                        <Box>
                                            {renderField(fieldKey, actualValue, fieldConfig)}
                                        </Box>
                                    </Box>
                                );
                            })}
                        </>
                    )}
                </Box>
            </ModalBody>

            <ModalFooter>
                <Button
                    className="btn-dark-blue"
                    onClick={onClose}
                >
                    {messages['close'] || 'Close'}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default DataDetailsModal;